import {
	ChangeDetectionStrategy,
	Component,
	HostBinding,
	Input
} from '@angular/core';

import styles from './VbScrubBarCurrentTime.module.less';

@Component({
	selector: 'vb-scrub-bar-current-time',
	changeDetection: ChangeDetectionStrategy.OnPush,
	template: ``,
	host: {
		'[class]': 'styles.root'
	},
    standalone: false
})
export class VbScrubBarCurrentTimeComponent {
	@Input() @HostBinding('style.width') public scrubBarPercentage: string;

	public readonly styles = styles;
}
